import { Dialog, Button, Icons, Icon, Intent } from 'construct-ui';

export const messageType = {
  WARNING: 1,
  ERROR: 2,
  INFORMATION: 3,
  CONFIRM: 4,
};

export function messageComponent() {

  var onClosed = (e) => { };
  var onAction = (e) => { };
  var isOpen = false;
  var message = "";
  var title = "";
  var messageList = [];
  var msgType = messageType.INFORMATION;
  let urlParams = {};

  let getIcon = () => {
    var ico = {
      intent: Intent.POSITIVE,
      name: Icons.INFO,
      size: 'xl'
    };
    if (msgType == messageType.WARNING) {
      ico.intent = Intent.WARNING;
      ico.name = Icons.ALERT_TRIANGLE;
    } else if (msgType == messageType.ERROR) {
      ico.intent = Intent.NEGATIVE;
      ico.name = Icons.X_CIRCLE;
    } else if (msgType == messageType.CONFIRM) {
      ico.intent = Intent.NONE;
      ico.name = Icons.HELP_CIRCLE;
    }
    return ico;
  }

  return {

    view: (vnode) => {
      if (vnode.attrs.isOpen != undefined) {
        isOpen = vnode.attrs.isOpen;
      }
      if (vnode.attrs.message != undefined) {
        message = vnode.attrs.message;
      }
      if (vnode.attrs.messageList != undefined) {
        messageList = vnode.attrs.messageList;
      }
      if (vnode.attrs.title != undefined) {
        title = vnode.attrs.title;
      }
      if (vnode.attrs.urlParams != undefined){
        urlParams = vnode.attrs.urlParams;
      }
      if (vnode.attrs.onClosed) {
        onClosed = vnode.attrs.onClosed;
      }
      if (vnode.attrs.msgType) {
        msgType = vnode.attrs.msgType;
      }
      if (vnode.attrs.onAction) {
        onAction = vnode.attrs.onAction;
      }

      return m(Dialog, {
        isOpen: isOpen,
        onClose: (e) => {
          isOpen = false; onClosed(e);
        },
        title: title,
        'class': 'cui-dialog-msgbox',
        transitionDuration: 200,
        closeOnOutsideClick: urlParams.r && urlParams.t && urlParams.reportGuid ? false : true,
        hasCloseButton: urlParams.r && urlParams.t && urlParams.reportGuid ? false : true,
        content: m('.row',
          (message && message != '') && m('div', { "style": "display: flex" },
            m("div", { "style": "margin-right:15px;" },
              m(Icon, getIcon())
            ),
            m("div", { "style": "flex-grow: 1" }, m('span', message))
          ),
          messageList.map(msg => [
            m('.row.col-md-12',
              m('div', { "style": "display: flex" },
                m("div", { "style": "margin-right:15px;" },
                  m(Icon, getIcon())
                ),
                m("div", { "style": "flex-grow: 1" }, m('span', msg.message))

              )
            ),
          ]),
        ),
        footer: urlParams.r && urlParams.t && urlParams.reportGuid ? [] : [
          m('.d-flex.justify-content-end',
            (msgType != messageType.CONFIRM) ? m(Button, {
              label: "Close",
              intent: 'primary',
              onclick: (e) => {
                isOpen = false; onClosed(e);
              }
            }) : [
              m(Button, {
                label: "Yes",
                intent: 'primary',
                onclick: (e) => {
                  isOpen = false; onAction("YES");
                }
              }),
              m(Button, {
                label: "No",
                intent: 'primary',
                onclick: (e) => {
                  isOpen = false; onAction("NO");
                }
              })
            ]
          )
        ]
      });
    }
  }
}
